import _styled from "@emotion/styled-base";
import { css } from '@emotion/core';
import { variables as vars, media } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font;
export var ListingSummary = _styled("div", {
  target: "e1qpx1sw0"
})("color:", colour.neutral700, ";font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";position:relative;margin-bottom:16px;");
export var watchlist = {
  name: "146q31f",
  styles: "float:right;"
};
export var onlineAuction = {
  name: "1vdq46e",
  styles: "margin-top:13px;"
};
export var Title = _styled("h3", {
  target: "e1qpx1sw1"
})("margin-top:18px;font-weight:", font.headingFontWeight, ";line-height:", font.baseMobileLineHeight, ";word-wrap:break-word;hyphens:auto;", media('>=desktop'), "{line-height:", font.baseLineHeight, ";}");
export var statsContainer = hasFeatures => /*#__PURE__*/css("margin:15px 0;", media('>=tablet'), "{border-top:", colour.neutral200, " solid 1px;border-bottom:none;", hasFeatures && /*#__PURE__*/css("padding:15px 0;border-bottom:", colour.neutral200, " solid 1px;"), ";}");
export var btrPillContainer = {
  name: "1y0ov1h",
  styles: "margin:24px 0 8px;"
};